var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormazione(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41702 24C7.08207 24 6 25.1192 6 26.4999C6 27.8806 7.0823 29 8.41702 29H27V24H8.41702Z",
    fill: "#EFEDEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44413 28.8996C7.12746 28.8996 6.0602 27.8112 6.0602 26.4691C6.0602 25.1264 7.12768 24.0383 8.44413 24.0383H26.97C27.5389 24.0383 28 23.568 28 22.988V2.05034C28 1.47012 27.5389 1 26.97 1H8.13208C5.84985 1 4 2.88622 4 5.2128V26.7872C4 29.1138 5.85007 31 8.13208 31H26.97C27.5389 31 28 30.5299 28 29.9497C28 29.3697 27.5389 28.8996 26.97 28.8996H8.44413Z",
    fill: "#FD6F71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.97 28.8996H8.44413C7.12746 28.8996 6.0602 27.8112 6.0602 26.4691C6.0602 25.1264 7.12768 24.0383 8.44413 24.0383H9.64765V1H8.13208C5.84985 1 4 2.88622 4 5.2128V26.7872C4 29.1138 5.85007 31 8.13208 31H26.97C27.5389 31 28 30.5299 28 29.9497C28 29.3697 27.5389 28.8996 26.97 28.8996Z",
    fill: "#FD6F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormazione);
export default __webpack_public_path__ + "static/media/formazione.03503bf5b201f2eb6c8c6c8e19d78e0d.svg";
export { ForwardRef as ReactComponent };